// extracted by mini-css-extract-plugin
module.exports = {"authorContainer":"HomePage_authorContainer__3GSaf","mpcasContainer":"HomePage_mpcasContainer__1nYDN"};